import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCopiersList} from '../../../apis/copier/copiers'

const PAGE_SIZE = 10

export interface CopierDto {
    filter_status: string
    exchange: string
    sortBy: string
    currentPage: number
}

const useQueryCopierList = (filter_status?: string, exchange?: string, sortBy?: string, currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getCopiers(exchange, filter_status, sortBy, exchange, currentPage),
        queryFn: async () => {
            const {data, pageInfo} = await getCopiersList(PAGE_SIZE, currentPage, filter_status, exchange, sortBy)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryCopierList
